import { render, staticRenderFns } from "./AddSMSMethodForm.vue?vue&type=template&id=990a8ec0&scoped=true"
import script from "./AddSMSMethodForm.vue?vue&type=script&lang=ts"
export * from "./AddSMSMethodForm.vue?vue&type=script&lang=ts"
import style0 from "./AddSMSMethodForm.vue?vue&type=style&index=0&id=990a8ec0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a8ec0",
  null
  
)

export default component.exports